export function getLocalDateString(defaultDate=undefined) {
  const date = defaultDate ? new Date(defaultDate) : new Date();

  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

export function getLocalDateStringISO(defaultDate=undefined) {
  const date = defaultDate ? new Date(defaultDate) : new Date();

  const offset = date.getTimezoneOffset();
  const localDate = new Date(date.getTime() - offset * 60000);

  return localDate.toISOString().slice(0, -1);
}